import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  result: { data: null, loading: false },
  envs: { data: [], loading: false },
  designs: { data: [], total: 0, pageNum: 0, pageSize: 0, loading: false },
  designShows: { data: [], total: 0, pageNum: 0, pageSize: 0, loading: false },
  rooms: { data: [], total: 0, pageNum: 0, pageSize: 0, loading: false },
  maps: { data: [], total: 0, pageNum: 0, pageSize: 0, loading: false },
  packages: { data: [], total: 0, pageNum: 0, pageSize: 0, loading: false },
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
